import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { api } from '@/lib/api';
import { dashboardForRole } from '@/lib/routes';
export const useAuth = () => {
    const { user, accessToken, setSession, clear, setAccessToken, setUser } = useAuthStore();
    const navigate = useNavigate();
    const login = async (username, password) => {
        const r = await api.post('/auth/login', { username, password });
        setSession(r.data.accessToken, r.data.user);
        navigate(dashboardForRole(r.data.user.role));
    };
    const logout = async () => {
        try {
            await api.post('/auth/logout');
        }
        catch { /* no-op */ }
        clear();
        navigate('/login');
    };
    return { user, accessToken, login, logout, setAccessToken, setUser };
};
// Hook that tries to refresh the session once on app boot.
export const useBootstrapSession = () => {
    const [ready, setReady] = useState(false);
    const { setSession, clear } = useAuthStore();
    useEffect(() => {
        const run = async () => {
            try {
                const r = await axios.post('/api/auth/refresh', null, { withCredentials: true });
                setSession(r.data.accessToken, r.data.user);
            }
            catch {
                clear();
            }
            finally {
                setReady(true);
            }
        };
        run();
    }, [setSession, clear]);
    return ready;
};
